import React, { useState, useEffect } from "react";
import ReactPlayer from "react-player";
import AwesomeSlider from "react-awesome-slider";
import "react-awesome-slider/dist/styles.css";
import { fetchTestimonials } from "../components/apifa"; // Assuming this fetches the testimonials

const TestimonialCarousel = () => {
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    const getTestimonials = async () => {
      try {
        const data = await fetchTestimonials();
        setTestimonials(data);
        console.log(data);
      } catch (error) {
        console.error("Error fetching testimonials:", error);
      }
    };

    getTestimonials();
  }, []);

  if (testimonials.length === 0) {
    return <p>Loading testimonials...</p>;
  }

  return (
    <section className="py-20">
      <div className="container mx-auto px-4 max-w-screen-sm md:max-w-screen-md lg:max-w-screen-md">

        <h1
          style={{ fontFamily: "Open Sans" }}
          className="w-fit mx-auto relative text-myBlue text-3xl md:text-5xl mb-12 
          before:absolute before:w-1/2 before:h-1 before:bg-myYellow before:-bottom-4 before:left-1/2 before:-translate-x-1/2"
        >
          Testimonials
        </h1>
        <div className="w-full  h-[100%] bg-myYellow shadow-md rounded-md">
    
        <AwesomeSlider
  className="flex items-center justify-center mb-8 "
  bullets={true}
  organicArrows={true}
  startup={true}
>
  {testimonials.map((testimonial, index) => (
    <div key={index} className="flex justify-center">
      <div className="w-full max-w-lg h-[95%] bg-myYellow shadow-md rounded-md p-4">
        {/* Title Section */}
        <div className="text-center text-myBlue font-semibold text-xl mb-2">
          {testimonial.title}
        </div>
        
        {/* Video Section */}
        <ReactPlayer
          url={testimonial.video_url}
          controls
          width="100%"
          height="100%"
          className="rounded-lg"
        />
      </div>
    </div>
  ))}
</AwesomeSlider>
</div>
      </div>
    </section>
  );
};

export default TestimonialCarousel;
